import { combineEpics } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import { signUp } from '../utils/api';
import { SignUpApi } from '../parsers';

import {
  SIGN_UP_REQUESTED,
  signUpSucceeded,
  signUpFailed,
} from '../redux/account';

import type { ActionObs, Store, Obs } from '../types';

export function signUpEpic(action$: ActionObs, store: Store): Obs {
  return action$
    .ofType(SIGN_UP_REQUESTED)
    .switchMap(
      ({ payload: { allowMarketing, email, password, userAgent } }) => {
        if (email.length && password.length) {
          return signUp({
            account: {
              allow_marketing: allowMarketing,
              password,
              user_agent: userAgent,
            },
            email_address: email,
          })
            .map(response => {
              // Why do we do this? Because the api returns a 200 even when
              // you are unauthorized. So you have to keep this, no matter
              // how much it pains you.
              if (response.status === 'error') throw Error(response.message);
              return response;
            })
            .map(resp => SignUpApi.parse(resp))
            .map(({ account }) => signUpSucceeded(account, 'email'))
            .catch(err => {
              return Observable.of(signUpFailed({ message: err.message }));
            });
        } else {
          return Observable.of(
            signUpFailed(
              email.length
                ? { message: 'Password is required.', errorType: 'password' }
                : { message: 'Email address is required.', errorType: 'email' },
            ),
          );
        }
      },
    );
}

/**
 * This technically also intercepts LOGIN_SUCCEEDED but the `redirectUrl` param
 * is part of `openSignUpModalWithRedirect`, so the epic for both is placed here.
 *
 * Basically when the signup modal is opened via a link that authenticates, it stores a redirectUrl
 * within the store. When the user signs up OR logs in, we want to redirect them to
 * where the authenticated link would have taken them.
 */

export default combineEpics(signUpEpic);
